let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fY7IH")).then(() => parcelRequire('akzYW'));